/** Three container:
 * <div> below is the container of the canvas;
 * optionally, create a canvas here instead of <div> 
 * 
 * @ref attribute gets a reference to the div element
 * sketch will run when the function componentDidMount() 
 * is automatically called by React, when the component is mounted.
 */

import React from 'react';
import SceneController from './SceneController';

export default class Home extends React.Component {
    componentDidMount() {
        this.threeRootElement.style.outline = 'none';
        this.sceneController = new SceneController(this.threeRootElement);
        this.addEventListeners();
        this.sceneController.setup();
        this.update();
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize);
        document.removeEventListener("mousedown", this.onDocumentMouseDown);
        if (this.sceneController) this.sceneController.dispose();
    };

    addEventListeners() {
        window.addEventListener('resize', this.onWindowResize, false);
        document.addEventListener("mousedown", this.onDocumentMouseDown, false);
    };

    onWindowResize = () => {
        if (this.sceneController) {
            this.sceneController.onWindowResize();
            this.sceneController.update();
        }
    };

    onDocumentMouseDown = (e) => {
        e.preventDefault();
        if (this.sceneController) this.sceneController.onMouseDown(e);
    };

    update = () => {
        requestAnimationFrame(this.update);
        if (this.sceneController) this.sceneController.update();
    };

    render() {
        return (
            <div ref={element => this.threeRootElement = element}>
                <Text />
            </div>
        );
    }
};

const Text = () => {
    return (
        <div className="Info">
            CLICK to break
        </div>
    );
}